import { render, staticRenderFns } from "./goods-classify.vue?vue&type=template&id=2607d1bc&scoped=true"
import script from "./goods-classify.vue?vue&type=script&lang=js"
export * from "./goods-classify.vue?vue&type=script&lang=js"
import style0 from "./goods-classify.vue?vue&type=style&index=0&id=2607d1bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607d1bc",
  null
  
)

export default component.exports